import { getAmplitudeInstance } from '../amplitudeHelpers';
import FeaturePreviewEligibility from '../enums/FeaturePreviewEligibility';
import FlyoverSource from '../enums/FlyoverSource';
import TrailPageCTAText from '../enums/TrailPageCTAText';
import TrailPageType from '../enums/TrailPageType';

type logFlyoverStartButtonTappedParams = {
  cta_text?: TrailPageCTAText;
  custom_route_id?: number;
  eligibility?: FeaturePreviewEligibility;
  source: FlyoverSource;
  trail_id?: number;
  trail_page_type?: TrailPageType;
};

/**
 * User taps on the “Preview Route” CTA, either on the Trail Details Page or the Map Details Page.
 * @param params - Attributes to log with the amplitude event
 * @param params.cta_text - In cases where the map CTA is a button, the text of the CTA the user clicked.
 * @param params.custom_route_id - The ID of the custom route being previewed.
 * @param params.eligibility - Whether or not a user has the ability to pro feature depending on pro status or previous usage of the feature teaser. Current options: pro_eligible, first_view, second_view
 * @param params.source - The source where of Preview Route.  Currently, web has two options: trail details or map details, but mobile only has one option: trail details.
 * @param params.trail_id - The ID of the trail being previewed.
 * @param params.trail_page_type - Type of trail page where the Preview Route CTA was tapped.
 */
const logFlyoverStartButtonTapped = (
  { cta_text, custom_route_id, eligibility, source, trail_id, trail_page_type }: logFlyoverStartButtonTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'flyover start button tapped',
    { 'cta text': cta_text, 'custom route id': custom_route_id, eligibility, source, 'trail id': trail_id, 'trail page type': trail_page_type },
    callback
  );
};

export default logFlyoverStartButtonTapped;
